import {
  PrenotazioneView,
  PrenotazioniFolderView,
  PrenotazioniExportView,
  AreaPersonaleView,
} from './components/View';
import {
  CustomTimesWidget,
  AdditionalFieldsSchemaWidget,
} from './components/manage/Widgets';
import { IoPrenotoBlocks } from './config/blocks';
import { defineMessages } from 'react-intl';
import {
  listUO,
  availableSlots,
  bookingSchema,
  prenotazione,
  vocOreList,
  vocBookingTypes,
  prenotazioniList,
  addVacation,
  bookingMove,
  deleteBookingResponse,
  bookingReminder,
  updateBooking,
} from './reducers/booking';
import { dayBusySlots } from './reducers/slots';
import {
  workflow as bookingWorkflow,
  workflowHistory as bookingHistory,
} from './reducers/workflow';

import bookingFolderIcon from './icons/booking-folder.svg';

const messages = defineMessages({
  prenotazioni_week_view: {
    id: 'prenotazioni_week_view',
    defaultMessage: 'Cartella prenotazioni',
  },
  prenotazione_appuntamenti_uffici_brdc: {
    id: 'prenotazione_appuntamenti_uffici_brdc',
    defaultMessage: 'Prenotazione appuntamento',
  },
  prenotazione_appuntamenti_personali_brdc: {
    id: 'prenotazione_appuntamenti_personali_brdc',
    defaultMessage: 'Le mie prenotazioni',
  },
  prenotazione_appuntamenti_export_brdc: {
    id: 'prenotazione_appuntamenti_export_brdc',
    defaultMessage: 'Export appuntamenti',
  },
});

const applyConfig = (config) => {
  config.widgets.id.week_table_overrides = CustomTimesWidget;
  config.widgets.views.id.booking_additional_fields_schema =
    AdditionalFieldsSchemaWidget;

  config.settings.contentIcons = {
    ...config.settings.contentIcons,
    PrenotazioniFolder: bookingFolderIcon,
  };

  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/prenotazione-appuntamenti-uffici',
      component: PrenotazioneView,
      exact: true,
      breadcrumbs_title: messages.prenotazione_appuntamenti_uffici_brdc,
    },
    {
      path: '/prenotazione-appuntamenti-personali',
      component: AreaPersonaleView,
      exact: true,
      breadcrumbs_title: messages.prenotazione_appuntamenti_personali_brdc,
    },
    {
      path: '/prenotazione-appuntamenti-export',
      component: PrenotazioniExportView,
      exact: true,
      breadcrumbs_title: messages.prenotazione_appuntamenti_export_brdc,
    },
  ];

  IoPrenotoBlocks(config);

  config.addonReducers = {
    ...config.addonReducers,
    listUO,
    availableSlots,
    bookingSchema,
    prenotazione,
    vocOreList,
    vocBookingTypes,
    prenotazioniList,
    addVacation,
    dayBusySlots,
    bookingMove,
    deleteBookingResponse,
    bookingWorkflow,
    bookingHistory,
    bookingReminder,
    updateBooking,
  };

  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    /\/prenotazione-appuntamenti-uffici$/,
    /\/prenotazione-appuntamenti-uffici\/.*$/,
    /\/prenotazione-appuntamenti-export$/,
    /\/prenotazione-appuntamenti-export\/.*$/,
  ];

  config.settings['volto-blocks-widget'].allowedBlocks = [
    ...config.settings['volto-blocks-widget'].allowedBlocks,
    'bookingButton',
  ];

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    PrenotazioniFolder: PrenotazioniFolderView,
    // PrenotazioneType: PrenotazioneTypeView,
  };

  config.views.layoutViewsNamesMapping = {
    ...config.views.layoutViewsNamesMapping,
    prenotazioni_week_view: 'prenotazioni_week_view',
  };

  config.settings.siteProperties.userLoggedMenu = [
    ...(config.settings.siteProperties.userLoggedMenu || []),
    {
      href: { it: '/prenotazione-appuntamenti-personali' },
      title: { it: 'Le mie prenotazioni' },
      roles: ['Citizen'],
      className: 'link-areaPersonale',
    },
  ];

  config.settings['volto-feedback'] = {
    ...config.settings['volto-feedback'],
    /* Enable Feedback component in your CMS/Non content routes. */
    feedbackEnabledNonContentRoutes: [
      ...config.settings['volto-feedback'].feedbackEnabledNonContentRoutes,
      {
        path: '/prenotazione-appuntamenti-personali',
        feedbackTitle: messages.prenotazione_appuntamenti_personali_brdc,
      },
      {
        path: '/prenotazione-appuntamenti-uffici',
        feedbackTitle: messages.prenotazione_appuntamenti_uffici_brdc,
      },
      {
        path: '/prenotazione-appuntamenti-export',
        feedbackTitle: messages.prenotazione_appuntamenti_export_brdc,
      },
    ],
  };

  return config;
};

export default applyConfig;
